import React, { useState } from 'react';
import { Col } from '../../../lib/utils';
import { Body3Bold, Body3Regular, CaptionRegular } from '../../../lib/font';
import { colors } from '../../../lib/colors';

interface MessagePreviewProps {
    message: string;
}

const EXPANDABLE_LENGTH = 44;

const MessagePreview: React.FC<MessagePreviewProps> = ({ message }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const isExpandable = message.length > EXPANDABLE_LENGTH;

    return (
        <Col
            style={{
                width: '100%',
                backgroundColor: '#FFFFFF',
                borderRadius: 16,
                padding: '20px',
                boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
            }}
        >
            <Body3Bold style={{ color: colors.LAVEL_4 }}>함께 보낼 메시지</Body3Bold>
            <Body3Regular
                style={{
                    marginTop: 10,
                    color: colors.LAVEL_2,
                    lineHeight: '22px',
                    whiteSpace: 'pre-wrap',
                    ...(!isExpanded && {
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical' as const,
                        overflow: 'hidden',
                    }),
                }}
            >
                {message}
            </Body3Regular>
            {isExpandable && (
                <button
                    onClick={() => setIsExpanded((prev) => !prev)}
                    style={{
                        alignSelf: 'flex-start',
                        marginTop: 8,
                        padding: 0,
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                    }}
                >
                    <CaptionRegular style={{ color: colors.primary, fontWeight: 600 }}>
                        {isExpanded ? '접기' : '펼치기'}
                    </CaptionRegular>
                </button>
            )}
        </Col>
    );
};

export default MessagePreview;
